import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import { unselectedPanelPointsState } from "~/containers/LegacyDesigner/state/elements/panels"
import { zoomState } from "~/containers/LegacyDesigner/state/view"

const UnselectedSnapPoints: FC = () => {
  const unselectedPanelPoints = useRecoilValue(unselectedPanelPointsState)
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {unselectedPanelPoints.flat().map((snapPoint, idx) => {
        const screenPoint = studioToScreen.point(snapPoint, zoom)

        return (
          <circle
            key={JSON.stringify(snapPoint) + idx}
            cx={screenPoint.x}
            cy={screenPoint.y}
            r="5"
            fill="blue"
          />
        )
      })}
    </>
  )
}

export default UnselectedSnapPoints
